import React from 'react';
import {useLocation, useLoaderData} from '@remix-run/react';

//components
import {Link} from 'components/Link';

//domains
import type {SanityBlogTag, SanityBlogCategory} from 'domains/blog';

interface Props {
  blogSettings: {
    blogs_label: string;
    categories_label: string;
    tags_label: string;
    recent_posts_label: string;
  };
  currentTag: SanityBlogTag | null;
  currentCategory: SanityBlogCategory | null;
}

export default function BlogListingBreadcrumb({
  blogSettings,
  currentTag,
  currentCategory,
}: Props) {
  const {pathname} = useLocation();
  const {translation} = useLoaderData()

  return (
    <nav className="mt-6 mb-[65px] flex flex-wrap items-center">
      <Link
        to="/"
        className="transition-colors duration-200 ease-out hover:text-hk-orange"
      >
        {translation?.home ?? 'Home'}
      </Link>
      <span className="mx-2 inline-block">/</span>
      {pathname === '/blogs' ? (
        <>
          <span className={pathname.includes('/blogs') ? 'text-hk-orange' : ''}>
            {blogSettings?.blogs_label}
          </span>
        </>
      ) : (
        <>
          <Link
            to="/blogs"
            className="transition-colors duration-200 ease-out hover:text-hk-orange"
          >
            {blogSettings?.blogs_label}
          </Link>
          {currentTag && (
            <>
              <span className="mx-2 inline-block">/</span>
              <span
                className={pathname.includes('/blogs') ? 'text-hk-orange' : ''}
              >
                {currentTag.title}
              </span>
            </>
          )}
          {currentCategory && (
            <>
              <span className="mx-2 inline-block">/</span>
              <span
                className={pathname.includes('/blogs') ? 'text-hk-orange' : ''}
              >
                {currentCategory.category_title}
              </span>
            </>
          )}
        </>
      )}
    </nav>
  );
}
